export const HEALTH_CONNECT_FALLBACK_DEVICE_ID = 'android-health-connect';

export const healthConnectDeviceId = (connection = null) =>
  connection?.id || connection?.device_id || HEALTH_CONNECT_FALLBACK_DEVICE_ID;

export const healthConnectAppInstanceId = (connection = null) =>
  connection?.app_instance_id || healthConnectDeviceId(connection);

export const buildHealthConnectScheduleRequest = ({
  apiUrl,
  connection = null,
  lastProviderTimestamp = null,
} = {}) => {
  const deviceId = healthConnectDeviceId(connection);
  return {
    apiUrl,
    connectionId: deviceId,
    appInstanceId: healthConnectAppInstanceId(connection),
    lastProviderTimestamp:
      lastProviderTimestamp ||
      connection?.last_provider_timestamp ||
      connection?.last_sync_at ||
      null,
  };
};

export const statusFromHealthConnectBackgroundResult = (status) => {
  if (status?.scheduled) return 'scheduled';
  const code = status?.errorCode;
  if (code === 'permission_required') return 'permission_required';
  if (code === 'auth_required') return 'auth_required';
  if (code === 'sync_config_missing') return 'config_missing';
  if (code) return 'failed';
  return 'disabled';
};

export const buildHealthConnectSourceStatusReport = (status = null) => ({
  status: statusFromHealthConnectBackgroundResult(status),
  background_sync_enabled: Boolean(status?.scheduled),
  error_code: status?.errorCode || null,
});

export const shouldAttemptHealthConnectAutoSchedule = ({
  androidNative,
  authenticated,
  loading,
  alreadyAttempted,
} = {}) => Boolean(androidNative && authenticated && !loading && !alreadyAttempted);
